var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgECollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 13.6326 0.0526784 13.7598 0.146447 13.8536C0.240215 13.9473 0.367392 14 0.5 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5V5.5C14 5.36739 13.9473 5.24021 13.8536 5.14645C13.7598 5.05268 13.6326 5 13.5 5H12.75V3C12.75 2.86739 12.6973 2.74021 12.6036 2.64645C12.5098 2.55268 12.3826 2.5 12.25 2.5H11.5V0.5C11.5 0.367392 11.4473 0.240215 11.3536 0.146447C11.2598 0.0526784 11.1326 0 11 0H3C2.86739 0 2.74021 0.0526784 2.64645 0.146447C2.55268 0.240215 2.5 0.367392 2.5 0.5V2.5H1.75C1.61739 2.5 1.49021 2.55268 1.39645 2.64645C1.30268 2.74021 1.25 2.86739 1.25 3V5H0.5C0.367392 5 0.240215 5.05268 0.146447 5.14645C0.0526784 5.24021 0 5.36739 0 5.5V13.5ZM3.5 1H10.5V2.5H3.5V1ZM2.25 3.5H11.75V5H2.25V3.5ZM1 6H13V13H1V6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECollection);
export default __webpack_public_path__ + "static/media/e-collection.a5e6a850177079eeb3435fddd3e1e4dd.svg";
export { ForwardRef as ReactComponent };